module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "ch1"
    }
  }, [_c('div', {
    staticClass: "chapterHead"
  }, [_c('p', {
    staticClass: "centerImage0"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/ch1.jpg",
      "width": "4%"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Cool!” you exclaim to your best friends, Liz and Jake. “The field trip to the Wicked Wax Museum is today. I can’t believe our class gets to see it the day "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("before")]), _vm._v(" the grand opening.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Finally, Mr. Dunning’s History class won’t be such a bore,” Jake adds, flipping his black baseball cap around backward. “Mr. Dunning. More like Mr. Dull!”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“You said it,” Liz giggles. Her red curls bounce when she laughs. “Hey, why is it called the Wicked Wax Museum, anyway?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“That’s the name of the guy who owns it,” Jake explains. “Dr. Izzy Wicked. He made all the wax figures.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Well, according to Mr. Dull,” Liz adds, “the museum is supposed to bring history to life for us, or something like that.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Yeah, right.” Jake smirks. “And maybe the wax figures will come to life, too.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Oh, gross!” Liz cries. “You’re giving me the creeps, Jake.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Come on, you two,” you say. “The bus is here. Let’s be first in line so we can grab the backseats.”")]), _vm._v(" "), _c('p', {
    staticClass: "extractLetterText",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Go to "), _c('a', {
    attrs: {
      "href": "#/e9780545841733_ch002"
    }
  }, [_vm._v("PAGE 2")]), _vm._v(".")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-748b80bc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/e9780545841733_ch001.vue
// module id = 66
// module chunks = 0